import { Button, Stack } from "@mantine/core"
import { useEffect, useState } from "react"
import { AccountBalanceHistoryTable } from "atlas_forecasting_app/components/account_balance/account_balance_history_table"
import { IconCreditCard, appIcon } from "atlas_forecasting_app/components/common/icons"
import { EmptyState, ErrorAlert, LoadingState, PageHeader, SectionCard } from "atlas_forecasting_app/components/common/page_elements"
import { apiFetch } from "atlas_forecasting_app/lib/api_fetch"
import { RouterLink } from "atlas_forecasting_app/lib/router"

export function AccountBalanceHistoryPage({ onCurrentUserUpdate, stripeEnabled = false }) {
  const [transactions, setTransactions] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  useEffect(() => {
    let cancelled = false

    const refresh = async () => {
      setLoading(true)
      try {
        const data = await apiFetch("/api/me/account_balance_transactions")
        if (cancelled) return

        setTransactions(data.transactions || [])
        if (data.user) onCurrentUserUpdate?.(data.user)
        setError("")
      } catch (e) {
        if (cancelled) return
        setError(e.message)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    refresh()

    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Stack gap="lg">
      <PageHeader
        eyebrow="Account"
        variant="account"
        title="Balance history"
        subtitle="Recent top-ups, forecast charges, and wallet balance changes."
        action={
          stripeEnabled ? (
            <Button component={RouterLink} to="/account/add-funds" leftSection={appIcon(IconCreditCard, "inline")}>
              Add funds
            </Button>
          ) : null
        }
      />

      <ErrorAlert message={error} />

      <SectionCard variant="feature" title="Account ledger" subtitle="Most recent balance activity appears first.">
        {loading ? (
          <LoadingState label="Loading balance history..." />
        ) : transactions.length === 0 ? (
          <EmptyState
            title="No balance activity yet"
            message="When you fund your Atlas balance or request forecasts, those entries will appear here."
            action={
              stripeEnabled ? (
                <Button component={RouterLink} to="/account/add-funds" leftSection={appIcon(IconCreditCard, "inline")}>
                  Add funds
                </Button>
              ) : null
            }
          />
        ) : (
          <AccountBalanceHistoryTable transactions={transactions} />
        )}
      </SectionCard>
    </Stack>
  )
}
